export const SET_COIN = 'SET_COIN';
export const ADD_COIN = 'ADD_COIN';

export const SET_PAIR = 'SET_PAIR';
export const ADD_PAIR = 'ADD_PAIR';

export const READ_EXCHANGE = 'READ_EXCHANGE';
export const CREATE_EXCHANGE = 'CREATE_EXCHANGE';
export const UPDATE_EXCHANGE = 'UPDATE_EXCHANGE';
export const DELETE_EXCHANGE = 'DELETE_EXCHANGE';
export const REQUEST_OTP = 'REQUEST_OTP';
export const SUCCESS_OTP = 'SUCCESS_OTP';
export const REVOKE_OTP = 'REVOKE_OTP';

export const READ_SETUP_BIZ = 'READ_SETUP_BIZ';
export const CREATE_SETUP_BIZ = 'CREATE_SETUP_BIZ';
export const UPDATE_SETUP_BIZ = 'UPDATE_SETUP_BIZ';
export const DELETE_SETUP_BIZ = 'DELETE_SETUP_BIZ';

export const READ_SETUP = 'READ_SETUP';
export const CREATE_SETUP = 'CREATE_SETUP';
export const UPDATE_SETUP = 'UPDATE_SETUP';
export const DELETE_SETUP = 'DELETE_SETUP';

export const READ_SETUP_TECH = 'READ_SETUP_TECH';
export const CREATE_SETUP_TECH = 'CREATE_SETUP_TECH';
export const UPDATE_SETUP_TECH = 'UPDATE_SETUP_TECH';
export const DELETE_SETUP_TECH = 'DELETE_SETUP_TECH';

export const READ_STAT = 'READ_STAT';
export const CREATE_STAT = 'CREATE_STAT';
export const UPDATE_STAT_REQUEST = 'UPDATE_STAT_REQUEST';
export const UPDATE_STAT_SUCCESS = 'UPDATE_STAT_SUCCESS';
export const UPDATE_STAT_FAILURE = 'UPDATE_STAT_FAILURE';
export const DELETE_STAT = 'DELETE_STAT';

export const READ_USER = 'READ_USER';
export const CREATE_USER = 'CREATE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const DELETE_USER = 'DELETE_USER';

export const SET_COLLATERAL = 'SET_COLLATERAL';
export const UPDATE_COLLATERAL = 'UPDATE_COLLATERAL';
export const ADD_COLLATERAL = 'ADD_COLLATERAL';
export const BACK_COLLATERAL = 'BACK_COLLATERAL';

export const READ_EXCHANGE_BILLING = 'READ_EXCHANGE_BILLING';
export const SET_NEW_PAY = 'SET_NEW_PAY';

export const SET_TRADES = 'SET_TRADES';
export const SET_CONSTANT = 'SET_CONSTANT';
export const SET_EVENT = 'SET_EVENT';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const APPLY_CHANGES = 'APPLY_CHANGES';

export const UPDATE_EMAIL_SETUP = 'UPDATE_EMAIL_SETUP';

export const OPREATOR_AGREEMENT_STATE = 'OPREATOR_AGREEMENT_STATE';
export const BUSINESS_AGREEMENT_STATE = 'BUSINESS_AGREEMENT_STATE';

export const PLUGIN_BILLING = 'PLUGIN_BILLING';
export const PLUGIN_BILLING_POP_UP = 'PLUGIN_BILLING_POP_UP';
export const PLUGIN_NAME = 'PLUGIN_NAME';
export const ACTIVATED_PLUGIN_DATA = 'ACTIVATEDPLUGINDATA';
export const SET_DISCOUNTED_PERCENTAGE = 'SETDISCOUNTEDPERCENTAGE';
export const SET_UPDATED_PLUGIN = 'SETUPDATEDPLUGIN';
export const SET_SELECTED_PLUGIN = 'SETSELECTEDPLUGIN';
